import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// External Supabase project (for client meeting agency/employee lookup)
// Created lazily so a missing env var at bundle time doesn't crash the app.
let _supabaseExt: SupabaseClient | null = null;

export function getSupabaseExt(): SupabaseClient {
  if (!_supabaseExt) {
    const url = process.env.REACT_APP_EXT_SUPABASE_URL || '';
    const key = process.env.REACT_APP_EXT_SUPABASE_ANON_KEY || '';
    if (!url || !key) {
      throw new Error('External Supabase credentials are not configured.');
    }
    _supabaseExt = createClient(url, key);
  }
  return _supabaseExt;
}
